import type { GeoPermission } from '../../lib/geolocation.js';

/**
 * מצב ה-GPS במסך הסוכן כשהמשימה הבאה נפתחת לפי מיקום: בקשת הרשאה, שגיאות ברורות (במיוחד בטלפון), מצב המיקום
 * (דיוק) וכפתור "בדוק מיקום עכשיו". המרחק ליעד לא מוצג כאן בכוונה (לא מספיילרים) — הוא מופיע במפה.
 */
export function GeoPrompt({
  permission,
  error,
  accuracy,
  onRequest,
}: {
  permission: GeoPermission;
  error: string | null;
  /** דיוק המיקום האחרון במטרים; null = עדיין אין מיקום */
  accuracy: number | null;
  onRequest: () => void;
}) {
  const hasFix = accuracy !== null;
  const denied = permission === 'denied';

  return (
    <div className="term-panel geo-prompt" role="status">
      {!hasFix && (
        <div className="term-text term-line term-line--system">
          &gt; נדרש מיקום כדי לבדוק אם הגעת לנקודת המשימה.
        </div>
      )}

      {hasFix && (
        <div className="term-text term-line term-line--system">
          &gt; GPS פעיל · דיוק ±{Math.round(accuracy)} מ׳
        </div>
      )}
      {hasFix && accuracy > 100 && (
        <div className="term-text term-line term-line--amber">
          &gt; הדיוק נמוך — צאו למקום פתוח (הרחק ממבנים) כדי שהזיהוי יעבוד.
        </div>
      )}

      {error && !hasFix && (
        <div className={`term-text term-line ${denied ? 'term-line--error' : 'term-line--amber'}`}>&gt; {error}</div>
      )}

      <button type="button" className="btn btn--primary geo-prompt__btn" onClick={onRequest}>
        {hasFix ? 'בדוק מיקום עכשיו' : denied ? 'נסה שוב' : 'אפשר גישה למיקום'}
      </button>
    </div>
  );
}
